import React, { useEffect, useState, useContext, useCallback } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'
import { components, constants } from 'cng-web-lib'
import { Box, Divider, Grid, Typography, Tooltip, IconButton, InputAdornment } from '@material-ui/core'
import { FileForUserGetUserDetails, FileForUserGetPartyId } from 'src/common/FileForUserCommon'
import { NaAceStateCodeAutoCompleteField, NaCrewMasterAutoCompleteField, NaAcePartyMasterAutoCompleteField } from 'src/components/na/autocomplete/codemaintenance'
import ACEHighwayManifestTranslationText from './../contexts/ACEHighwayManifestTranslationText'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AciAceCrewTypeMapping } from 'src/common/AciAceCrossMapping'
import Alert from '../../../components/Alert'
import Switch from '../../../components/Switch'
import TinyChip from 'src/components/aciacehighway/TinyChip'
import CngSection from '../../../components/cngcomponents/CngSection'
import ToggleButtonGroup from '../../../components/aciacehighway/ToggleButtonGroup'
import TemplateSelectDialog from '../../../components/aciacehighway/TemplateSelectDialog'
import PAXLSTInternationalDocEntry from './PAXLSTInternationalDocEntry'
import PAXLSTInternationalDocFormProperties from './PAXLSTInternationalDocFormProperties'
import PartyMasterApiUrls from '../../../apiUrls/PartyMasterApiUrls'
import CrewMasterApiUrls from '../../../apiUrls/CrewMasterApiUrls'
import moment from 'moment-timezone'
import * as InputSource from 'src/common/InputSource'


const {
  button: { CngIconButton },
  form: {
    field: {
      CngTextField,
      CngDateField,
      CngSelectField,
      CngCodeMasterAutocompleteField,
      CngCountryAutocompleteField,
    },
  },
  CngGridItem,
  table: { useFetchCodeMaintenanceLookup },
} = components

const {
  filter: { LIKE, EQUAL, IN }
} = constants

const DEFAULT_INITIAL_VALUES = Object.freeze({
  id: '',
  dob: null,
  nationality: '',
  gender: '',
  partyType: '',
  address1: '',
  address2: '',
  address3: '',
  cityName: '',
  postalCode: '',
  country: 'US',
  state: '',
  telNo: '',
  email: '',
  internationalDoc: [],
  hazmatEndorsement: '',
  licenseNo: '',
  licenseCountry: '',
  licenseState: '',
  cdlNo: '',
  cdlCountry: '',
  cdlState: '',
  firstName: '',
  middleName: '',
  lastName: '',
  aceIdFlag: false,
  aceId: '',
  customProximityId: '',
  fastCardFlag: false
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES }
}

function Fields({ disabled, showNotification, shouldHideMap, index }) {
  const { getValues, setValue, watch, reset, trigger } = useFormContext();
  const aceHighwayManifestTranslationText = ACEHighwayManifestTranslationText()
  const { initialValues } = PAXLSTInternationalDocFormProperties.formikProps
  const fetchCodeMaintenanceLookup = useFetchCodeMaintenanceLookup()

  const getFieldName = useCallback((field) => {
    return typeof index === 'number' ? `paxLSTInfo.${index}.${field}` : field
  }, [])

  const [lookups, setLookups] = useState(null)
  const [partyTemplateDialog, setPartyTemplateDialog] = useState(false)
  const [locTemplateDialog, setLocTemplateDialog] = useState(false)

  const partyType = watch(getFieldName('partyType'))
  const aceIdFlag = watch(getFieldName('aceIdFlag'))
  const fastCardFlag = watch(getFieldName('fastCardFlag'))
  const internationalDoc = watch(getFieldName('internationalDoc'))
  const crewType = watch(getFieldName('partyType'))
  const cdlNo = useWatch({ name: getFieldName('cdlNo') })
  const cdlCountry = useWatch({ name: getFieldName('cdlCountry') })
  const licenseNo = useWatch({ name: getFieldName('licenseNo') })
  const licenseCountry = useWatch({ name: getFieldName('licenseCountry') })


  useEffect(() => {
    if (aceIdFlag) {
      setValue(getFieldName('customProximityId'), '')
    } else if (fastCardFlag) {
      setValue(getFieldName('aceId'), '')
    }
  }, [aceIdFlag, fastCardFlag])


  
  useEffect(() => {
    if (!aceIdFlag && !fastCardFlag && internationalDoc.length === 0) {
      const { initialValues } = PAXLSTInternationalDocFormProperties.formikProps
      setValue(getFieldName('internationalDoc'), [{ ...initialValues, _id: 1 }])
    }
  }, [aceIdFlag, fastCardFlag])

  useEffect(() => {
    Promise.all([
      // Crew Type
      fetchCodeMaintenanceLookup(
        constants.CodeMaintenanceType.CODE_MASTER,
        undefined,
        [{ field: 'codeType', operator: EQUAL, value: 'ACE_HW_CREW_TYPE' }],
        undefined,
        'code'
      )
    ]).then(([partyType]) => { setLookups({ partyType }) })
  }, [])


  useEffect(() => {
    let fileForUserDetails = FileForUserGetUserDetails();
    if (fileForUserDetails != null && fileForUserDetails != undefined) {
      setValue(getFieldName('fileForUserId'), fileForUserDetails.fileForUserId)
      setValue(getFieldName('fileForUserLoginId'), fileForUserDetails.fileForUserLoginId)
      setValue(getFieldName('fileForUserPartyId'), fileForUserDetails.fileForUserPartyId)
    }
  }, []);

  function getLookupValue(name, value) {
    if (!lookups) return value
    return lookups[name] && lookups[name][value] ? lookups[name][value] : value
  }

  // Crew Section template table
  const columns = [
    {
      title: `${aceHighwayManifestTranslationText.crewId} & ${aceHighwayManifestTranslationText.aceId} / ${aceHighwayManifestTranslationText.fastCard}`,
      render: (data) => {
        const { aceId, crewId, customProximityId } = data

        return (
          <Box>
            <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
              {crewId}
            </Typography>
            {(aceId || customProximityId) && (
              <Typography color='textSecondary' style={{ fontSize: 12, lineHeight: 1.2 }}>
                {aceId ? aceId : customProximityId}
                <TinyChip label={aceId ? 'ACE ID' : 'FAST Card'} variant='outlined' />
              </Typography>
            )}
          </Box>
        )
      }
    },
    {
      field: 'crewType',
      title: aceHighwayManifestTranslationText.crewType,
      render: (data) =>
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('partyType', data.crewType)}
        </Typography>
    },
    {
      field: 'firstName',
      title: aceHighwayManifestTranslationText.firstName
    },
    {
      field: 'middleName',
      title: aceHighwayManifestTranslationText.middleName
    },
    {
      field: 'lastName',
      title: aceHighwayManifestTranslationText.lastName
    },
    {
      field: 'licenseNo',
      title: aceHighwayManifestTranslationText.licenseNo
    }
  ]

  const sortOptions = [
    {
      label: aceHighwayManifestTranslationText.crewId,
      value: 'crewId'
    },
    {
      label: aceHighwayManifestTranslationText.crewType,
      value: 'crewType'
    },
  ]

  function handleApplyCrewTemplate(template) {
    if (!template) {
      reset()
      return
    }

    const {
      crewId,
      aceId,
      cdlCountry,
      cdlNo,
      cdlState,
      crewType,
      customProximityId,
      dob,
      email,
      firstName,
      gender,
      hazmatEndorsement,
      internationalDoc,
      lastName,
      licenseCountry,
      licenseNo,
      licenseState,
      middleName,
      nationality,
      telNo,
      address1,
      address2,
      address3,
      state,
      cityName,
      postalCode
    } = template

    const highwayPaxlstInterchange = [{ id: '39', value: 'AIG' }, { id: 'AEW', value: 'DM' }, { id: '6W', value: 'ACE' }, { id: 'AGS', value: 'AQY' }, { id: 'AEF', value: 'ARJ' }, { id: 'AGR', value: 'ASX' }, { id: 'ALR', value: 'ALR' }, { id: 'ALX', value: 'AVP' },
    { id: '989', value: 'AUB' }, { id: 'AGT', value: 'GN' }, { id: 'ALY', value: 'AFZ' }, { id: 'ACU', value: 'ET' }, { id: 'AAG', value: 'AGF' }, { id: 'ALV', value: 'ALV' }, { id: 'BCP', value: 'CR' }, { id: 'REP', value: 'REP' }, { id: 'RTP', value: 'RTP' }, { id: 'BCN', value: 'BCN' }, { id: 'CDN', value: 'CDN' }, { id: 'CON', value: 'CON' }, { id: 'OTD', value: 'OTD' }]

    const docList = internationalDoc.map((d, index) => ({
      docType: d.docType ? (highwayPaxlstInterchange.find(obj => {
        return obj.id === d.docType || obj.value === d.docType;
      }))?.id : d.docType,
      docNo: d.docNo,
      country: d.country,
      state: '',
      _id: index + 1
    }))
    setValue(getFieldName('fetchCrew'), crewId, { shouldDirty: true })

    const aceIdFlag = aceId ? true : false
    const fastCardFlag = customProximityId ? true : false

    setValue(getFieldName('aceIdFlag'), aceIdFlag, { shouldDirty: true })
    setValue(getFieldName('fastCardFlag'), fastCardFlag, { shouldDirty: true })

    setValue(getFieldName('aceId'), aceIdFlag ? aceId || '' : '', { shouldDirty: true })
    setValue(getFieldName('customProximityId'), fastCardFlag ? customProximityId || '' : '', { shouldDirty: true })
    setValue(getFieldName('partyType'), AciAceCrewTypeMapping('ACE', crewType) || '', { shouldDirty: true })
    setValue(getFieldName('firstName'), firstName || '', { shouldDirty: true })
    setValue(getFieldName('lastName'), lastName || '', { shouldDirty: true })
      
    if (!aceIdFlag && !fastCardFlag) {
      setValue(getFieldName('middleName'), middleName || '', { shouldDirty: true })
      setValue(getFieldName('gender'), gender || '', { shouldDirty: true })
      setValue(getFieldName('dob'), dob ? moment(dob).tz('Canada/Eastern').format('YYYY-MM-DD') : null, { shouldDirty: true })
      setValue(getFieldName('nationality'), nationality || '', { shouldDirty: true })
    }
    if (!fastCardFlag) {
      setValue(getFieldName('address1'), address1 || '', { shouldDirty: true })
      setValue(getFieldName('address2'), address2 || '', { shouldDirty: true })
      setValue(getFieldName('address3'), address3 || '', { shouldDirty: true })
      setValue(getFieldName('cityName'), cityName || '', { shouldDirty: true })
      setValue(getFieldName('postalCode'), postalCode || '', { shouldDirty: true })
      setValue(getFieldName('state'), state || '', { shouldDirty: true })
    }

    setValue(getFieldName('email'), email || '', { shouldDirty: true })
    setValue(getFieldName('telNo'), telNo || '', { shouldDirty: true })
      
    setValue(getFieldName('licenseNo'), licenseNo || '', { shouldDirty: true })
    setValue(getFieldName('licenseCountry'), licenseCountry || '', { shouldDirty: true })
    setValue(getFieldName('licenseState'), licenseState || '', { shouldDirty: true })
    setValue(getFieldName('cdlNo'), cdlNo || '', { shouldDirty: true })
    setValue(getFieldName('cdlCountry'), cdlCountry || '', { shouldDirty: true })
    setValue(getFieldName('cdlState'), cdlState || '', { shouldDirty: true })
    setValue(getFieldName('hazmatEndorsement'), hazmatEndorsement || '', { shouldDirty: true })
    setValue(getFieldName('internationalDoc'), internationalDoc ? docList : [], { shouldDirty: true })

    showNotification('success', aceHighwayManifestTranslationText.templateAppliedSuccessMsg)
    trigger()
  }
  // Party Section template table
  const dropOffLocPartyColumns = [
    {
      field: 'partytype',
      title: aceHighwayManifestTranslationText.partyType,
      render: (data) =>
        <Typography component='div' variant='inherit' style={{ marginBottom: 4 }}>
          {getLookupValue('partyType', data.partytype)}
        </Typography>
    },
    {
      field: 'partyidn',
      title: aceHighwayManifestTranslationText.partyIdentifier
    },
    {
      title: `${aceHighwayManifestTranslationText.name1}/${aceHighwayManifestTranslationText.name2}`,
      render: (data) => [data.partyname1, data.partyname2].join(' ')
    },
    {
      field: 'countrycode',
      title: aceHighwayManifestTranslationText.country
    },
    {
      field: 'statecode',
      title: aceHighwayManifestTranslationText.state
    },
  ]

  const dropOffLocPartySortOptions = [
    {
      label: aceHighwayManifestTranslationText.partyIdentifier,
      value: 'partyidn'
    },
    {
      label: aceHighwayManifestTranslationText.partyType,
      value: 'partytype'
    }
  ]

  function handleApplyLocTemplate(template) {
    if (!template) {
      reset()
      return
    }

    const {
      partyidn,
      address1,
      address2,
      address3,
      cityname,
      postalcode,
      statecode
    } = template

    setValue(getFieldName('partyDropDown'), partyidn || '', { shouldDirty: true })
    setValue(getFieldName('address1'), address1 || '', { shouldDirty: true })
    setValue(getFieldName('address2'), address2 || '', { shouldDirty: true })
    setValue(getFieldName('address3'), address3 || '', { shouldDirty: true })
    setValue(getFieldName('cityName'), cityname || '', { shouldDirty: true })
    setValue(getFieldName('postalCode'), postalcode || '', { shouldDirty: true })
    setValue(getFieldName('state'), statecode || '', { shouldDirty: true })
      
    trigger()
  }

  function handleAddInternationalDoc(data) {
    const internationalDoc = [...getValues(getFieldName('internationalDoc')), data].map(
      (document, index) => ({ ...document, _id: index + 1 })
    )

    setValue(getFieldName('internationalDoc'), internationalDoc)
  }

  function handleDeleteInternationalDoc(data) {
    const internationalDoc = [...getValues(getFieldName('internationalDoc'))].filter((document) =>
      document.id ? document.id !== data.id : document._id !== data._id
    )

    setValue(getFieldName('internationalDoc'), internationalDoc, { shouldDirty: true })
  }
  
	return (
    <>
      <Grid container spacing={2}>
        <CngGridItem xs={12}>
          <Grid container spacing={1}>
            <CngGridItem xs={12}>
              <Grid container spacing={1}>
                <CngGridItem xs={12} sm={6}>
                  <NaCrewMasterAutoCompleteField
                    name={getFieldName('fetchCrew')}
                    label={aceHighwayManifestTranslationText.fetchCrew}
                    disabled={disabled}
                    onChange={(_, options) => handleApplyCrewTemplate(options.data)}
                    lookupProps= {{
                      filters: [{
                        field: 'partyId',
                        operator: EQUAL,
                        value: FileForUserGetPartyId()
                      }]
                    }} 
                    size='small'
                    fullWidth
                    disableClearable
                    textFieldProps={{
                      InputProps: {
                        customEndAdornment: () => (
                          <InputAdornment position='end' style={{ marginTop: -16 }}>
                            <IconButton onClick={(event) => {
                              event.stopPropagation()
                              setPartyTemplateDialog(true)
                            }}>
                              <Box display='flex' alignItems='center' justifyContent='center' width={16} height={16}>
                                <FontAwesomeIcon icon={['fal', 'money-check-edit']} size='xs' />
                              </Box>
                            </IconButton>
                          </InputAdornment>
                        )
                      }
                    }}
                    forcePopupIcon={false}
                  />
                </CngGridItem>

                {aceIdFlag && (
                  <Grid item xs={12} sm={8}>
                    <Alert severity='info' icon={<FontAwesomeIcon icon={['fal', 'info-circle']} />}>
                      <strong>{aceHighwayManifestTranslationText.note}:</strong> {aceHighwayManifestTranslationText.paxlstInfoAddressTitle}
                    </Alert>
                  </Grid>
                )}

                {!aceIdFlag && !fastCardFlag && (
                  <Grid item xs={12} sm={8}>
                    <Alert severity='info' icon={<FontAwesomeIcon icon={['fal', 'info-circle']} />}>
                      <strong>{aceHighwayManifestTranslationText.note}:</strong> *{aceHighwayManifestTranslationText.personalInformationIsRequiredMsg}
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </CngGridItem>

            <CngGridItem xs={12} md={4} shouldHide={shouldHideMap?.crewType}>
              <CngCodeMasterAutocompleteField
                required
                name={getFieldName('partyType')}
                label={aceHighwayManifestTranslationText.crewType}
                disabled={disabled}
                codeType='ACE_HW_CREW_TYPE'
                key={partyType}
                size='small'
                onChange={(value) => setValue(getFieldName('partyType'), value)}
              />
            </CngGridItem>

            {aceIdFlag && (
              <CngGridItem xs={12} md={8} shouldHide={shouldHideMap?.aceId}>
                <CngTextField
                  required
                  name={getFieldName('aceId')}
                  label={aceHighwayManifestTranslationText.aceId}
                  disabled={disabled}
                  size='small'
                />
              </CngGridItem>
            )}

            {fastCardFlag && (
              <CngGridItem xs={12} md={8} shouldHide={shouldHideMap?.customProximityId}>
                <CngTextField
                  required
                  name={getFieldName('customProximityId')}
                  label={aceHighwayManifestTranslationText.fastCard}
                  disabled={disabled}
                  size='small'
                />
              </CngGridItem>
            )}

            <CngGridItem xs={12} md={6} shouldHide={shouldHideMap?.firstName}>
              <CngTextField
                required={!aceIdFlag && !fastCardFlag}
                name={getFieldName('firstName')}
                label={aceHighwayManifestTranslationText.firstName}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' } }}
                onBlur={(e) => { setValue(getFieldName('firstName'), e.target.value.toUpperCase()) }}
                size='small'
              />
            </CngGridItem>

            {!aceIdFlag && !fastCardFlag && (
              <CngGridItem xs={12} md={6} shouldHide={shouldHideMap?.middleName}>
                <CngTextField
                  name={getFieldName('middleName')}
                  label={aceHighwayManifestTranslationText.middleName}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  onBlur={(e) => { setValue(getFieldName('middleName'), e.target.value.toUpperCase()) }}
                  size='small'
                />
              </CngGridItem>
            )}

            <CngGridItem xs={12} md={6} shouldHide={shouldHideMap?.lastName}>
              <CngTextField
                required={!aceIdFlag && !fastCardFlag}
                name={getFieldName('lastName')}
                label={aceHighwayManifestTranslationText.lastName}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' } }}
                onBlur={(e) => { setValue(getFieldName('lastName'), e.target.value.toUpperCase()) }}
                size='small'
              />
            </CngGridItem>

            {partyType === 'VW' && (aceIdFlag || fastCardFlag) && (
              <>
                <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.telNo}>
                  <CngTextField
                    name={getFieldName('telNo')}
                    label={aceHighwayManifestTranslationText.telNo}
                    disabled={disabled}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.email}>
                  <CngTextField
                    name={getFieldName('email')}
                    label={aceHighwayManifestTranslationText.email}
                    disabled={disabled}
                    size='small'
                  />
                </CngGridItem>
              </>
            )}

            {!aceIdFlag && !fastCardFlag && (
              <>
                <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.telNo}>
                  <CngTextField
                    name={getFieldName('telNo')}
                    label={aceHighwayManifestTranslationText.telNo}
                    disabled={disabled}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.email}>
                  <CngTextField
                    name={getFieldName('email')}
                    label={aceHighwayManifestTranslationText.email}
                    disabled={disabled}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.gender}>
                  <CngSelectField
                    required
                    name={getFieldName('gender')}
                    label={aceHighwayManifestTranslationText.gender}
                    disabled={disabled}
                    items={[
                      { text: aceHighwayManifestTranslationText.male, value: 'M' },
                      { text: aceHighwayManifestTranslationText.female, value: 'F' },
                      { text: aceHighwayManifestTranslationText.x, value: 'X' }
                    ]}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.dob}>
                  <CngDateField
                    required
                    name={getFieldName('dob')}
                    label={aceHighwayManifestTranslationText.dob}
                    disabled={disabled}
                    size='small'
                  />
                </CngGridItem>
                <CngGridItem xs={12} sm={6} shouldHide={shouldHideMap?.nationality}>
                  <CngCountryAutocompleteField
                    required
                    name={getFieldName('nationality')}
                    label={aceHighwayManifestTranslationText.nationality}
                    disabled={disabled}
                    lookupProps={{
                      label: (record) => {
                        return `${record.code};${record.descriptionEn}`
                      }
                    }}
                    size='small'
                    key={getValues(getFieldName('nationality'))}
                  />
                </CngGridItem>
              </>
            )}
          </Grid>
        </CngGridItem>

        <CngGridItem xs={12}>
          <Divider />
        </CngGridItem>

        {!fastCardFlag && (
          <CngGridItem xs={12}>
            <Grid container spacing={1}>
              <CngGridItem xs={12} shouldHide={shouldHideMap?.partyDropDown}>
                <NaAcePartyMasterAutoCompleteField
                  name={getFieldName('partyDropDown')}
                  label={aceHighwayManifestTranslationText.partyDropDown}
                  disabled={disabled}
                  onChange={(_, options) => handleApplyLocTemplate(options.data)}
                  lookupProps={{
                    filters: [{
                      field: 'partyId',
                      operator: EQUAL,
                      value: FileForUserGetPartyId()
                    },
                      {
                        field: 'partytype',
                        operator: IN,
                        value: ['OS', 'CN', 'NI', 'GC', 'CB', 'IM', 'CZ', 'SH']
                    }]
                  }}
                  size='small'
                  fullWidth
                  disableClearable
                  textFieldProps={{
                    InputProps: {
                      customEndAdornment: () => (
                        <InputAdornment position='end' style={{ marginTop: -16 }}>
                          <IconButton onClick={(event) => {
                            event.stopPropagation()
                            setLocTemplateDialog(true)
                          }}>
                            <Box display='flex' alignItems='center' justifyContent='center' width={16} height={16}>
                              <FontAwesomeIcon icon={['fal', 'money-check-edit']} size='xs' />
                            </Box>
                          </IconButton>
                        </InputAdornment>
                      )
                    }
                  }}
                  forcePopupIcon={false}
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.address1}>
                <CngTextField
                  name={getFieldName('address1')}
                  label={aceHighwayManifestTranslationText.address1}
                  disabled={disabled}
                  required
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  onBlur={(e) => { setValue(getFieldName('address1'), e.target.value.toUpperCase()) }}
                  size='small'
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.address2}>
                <CngTextField
                  name={getFieldName('address2')}
                  label={aceHighwayManifestTranslationText.address2}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  onBlur={(e) => { setValue(getFieldName('address2'), e.target.value.toUpperCase()) }}
                  size='small'
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.address3}>
                <CngTextField
                  name={getFieldName('address3')}
                  label={aceHighwayManifestTranslationText.address3}
                  disabled={disabled}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  onBlur={(e) => { setValue(getFieldName('address3'), e.target.value.toUpperCase()) }}
                  size='small'
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.cityName}>
                <CngTextField
                  name={getFieldName('cityName')}
                  label={aceHighwayManifestTranslationText.cityName}
                  disabled={disabled}
                  required
                  onBlur={(e) => { setValue(getFieldName('cityName'), e.target.value.toUpperCase()) }}
                  inputProps={{ style: { textTransform: 'uppercase' } }}
                  size='small'
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.postalCode}>
                <CngTextField
                  name={getFieldName('postalCode')}
                  label={aceHighwayManifestTranslationText.postalCode}
                  disabled={disabled}
                  required
                  size='small'
                />
              </CngGridItem>

              <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.state}>
                <NaAceStateCodeAutoCompleteField
                  name={getFieldName('state')}
                  label={aceHighwayManifestTranslationText.state}
                  disabled={disabled}
                  countryCode={'US'}
                  required
                  size='small'
                  key={getValues(getFieldName('state'))}
                />
              </CngGridItem>
            </Grid>
          </CngGridItem>
        )}

        <CngGridItem xs={12}>
          <CngSection
            title={aceHighwayManifestTranslationText.internationalDoc}
            subheader={!aceIdFlag && !fastCardFlag ? (
                <Typography color='error' variant='caption'>
                  *{aceHighwayManifestTranslationText.required}
                </Typography>
              ) : null
            }>
            <Grid container spacing={1}>
              {internationalDoc.map((document, childIndex) => (
                <React.Fragment key={document._id || document.id || childIndex}>
                  <Grid item xs={12}>
                    <PAXLSTInternationalDocEntry
                      index={childIndex}
                      parentIndex={index}
                      isLast={internationalDoc.length === 1}
                      onAddInternationalDoc={handleAddInternationalDoc}
                      onDeleteInternationalDoc={handleDeleteInternationalDoc}
                      internationalDoc={document}
                      showNotification={showNotification}
                      crewType={getValues(getFieldName('partyType'))}
                      aceIdFlag={aceIdFlag}
                      fastCardFlag={fastCardFlag}
                    />
                  </Grid>
                  {internationalDoc.length !== childIndex + 1 && (
                    <Grid item xs={12}>
                      <Divider />
                    </Grid>
                  )}
                </React.Fragment>
              ))}
            </Grid>
            {internationalDoc.length === 0 && (
            <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs='auto'>
                <Tooltip placement='bottom' title='Add new'>
                  <span>
                    <CngIconButton
                      icon={['fal', 'plus']}
                      onClick={() => handleAddInternationalDoc(initialValues)}
                      size='small'
                      type='outlined'
                    />
                  </span>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          )}
          </CngSection>
        </CngGridItem>

        <CngGridItem xs={12}>
          {partyType === 'VW' && !fastCardFlag && !aceIdFlag ? (
            <Typography color='error' variant='caption'>
              *{aceHighwayManifestTranslationText.minOneLicenseIsRequiredMsg}
            </Typography>
          ) : null}
          <Grid container spacing={1}>
            <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.licenseNo}>
              <CngTextField
                name={getFieldName('licenseNo')}
                label={aceHighwayManifestTranslationText.licenseNo}
                disabled={disabled}
                inputProps={{ style: { textTransform: 'uppercase' } }}
                onBlur={(e) => { setValue(getFieldName('licenseNo'), e.target.value.toUpperCase()) }}
                required={crewType === 'VW' && !aceIdFlag && !fastCardFlag && cdlNo === ''}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.licenseCountry}>
              <CngCodeMasterAutocompleteField
                name={getFieldName('licenseCountry')}
                label={aceHighwayManifestTranslationText.licenseCountry}
                disabled={disabled}
                codeType='ACIHWY_MANIFEST_COUNTRY'
                onChange={() => { setValue(getFieldName('licenseStateState'), '') }}
                lookupProps={{
                  label: (record) => {
                    return `${record.code};${record.descriptionEn}`
                  }
                }}
                required={licenseNo !== null && licenseNo !== ''}
                size='small'
                key={getValues(getFieldName('licenseCountry'))}
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.licenseState}>
              <NaAceStateCodeAutoCompleteField 
                name={getFieldName('licenseState')}
                label={aceHighwayManifestTranslationText.licenseState}
                disabled={disabled}
                countryCode={licenseCountry}
                required={licenseNo !== null && licenseNo !== ''}
                size='small'
                key={getValues(getFieldName('licenseCountry'))}
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.cdlNo}>
              <CngTextField
                name={getFieldName('cdlNo')}
                label={aceHighwayManifestTranslationText.cdlNo}
                disabled={disabled}
                required={crewType === 'VW' && !aceIdFlag && !fastCardFlag && licenseNo === ''}
                size='small'
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.cdlCountry}>
              <CngCodeMasterAutocompleteField
                name={getFieldName('cdlCountry')}
                label={aceHighwayManifestTranslationText.cdlCountry}
                disabled={disabled}
                codeType='ACIHWY_MANIFEST_COUNTRY'
                onChange={() => { setValue(getFieldName('cdlStateState'), '') }}
                lookupProps={{
                  label: (record) => {
                    return `${record.code};${record.descriptionEn}`
                  }
                }}
                required={cdlNo !== null && cdlNo !== ''}
                size='small'
                key={getValues(getFieldName('cdlCountry'))}
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.cdlState}>
              <NaAceStateCodeAutoCompleteField 
                name={getFieldName('cdlState')}
                label={aceHighwayManifestTranslationText.cdlState}
                disabled={disabled}
                countryCode={cdlCountry}
                required={cdlNo !== null && cdlNo !== ''}
                size='small'
                key={getValues(getFieldName('cdlCountry'))}
              />
            </CngGridItem>
            <CngGridItem xs={12} sm={6} md={4} shouldHide={shouldHideMap?.hazmatEndorsement}>
              <Switch
                fullWidth
                name={getFieldName('hazmatEndorsement')}
                label={aceHighwayManifestTranslationText.hazmatEndorsement}
                disabled={disabled}
              />
            </CngGridItem>
          </Grid>
        </CngGridItem>
      </Grid>

      <TemplateSelectDialog
        columns={columns}
        defaultSorts={[{ field: 'crewId', direction: 'ASC' }]}
        fetch={{ url: CrewMasterApiUrls.GET }}
        fetchFilters={[
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() },
          { field: 'inputSource', operator: EQUAL, value: InputSource.ACE_HWY_MANIFEST_PAXLST }
        ]}
        onApplyTemplate={handleApplyCrewTemplate}
        onClose={() => setPartyTemplateDialog(false)}
        open={partyTemplateDialog}
        search={{ field: 'inputValue', operator: LIKE }}
        sortOptions={sortOptions}
        title='Crew template'
      />

      <TemplateSelectDialog
        columns={dropOffLocPartyColumns}
        defaultSorts={[{ field: 'partyidn', direction: 'ASC' }]}
        fetch={{ url: PartyMasterApiUrls.SEARCH }}
        fetchFilters={[
          { field: 'partytype', operator: IN, value: ['OS', 'CN', 'NI', 'GC', 'CB', 'IM', 'CZ', 'SH'] },
          { field: 'partyId', operator: EQUAL, value: FileForUserGetPartyId() }
        ]}
        onApplyTemplate={handleApplyLocTemplate}
        onClose={() => setLocTemplateDialog(false)}
        open={locTemplateDialog}
        search={{ field: 'partyidn', operator: LIKE }}
        sortOptions={dropOffLocPartySortOptions}
        title='Drop Off Location Party template'
      />
    </>
	)
}

const PartyInfoFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default PartyInfoFormProperties
